<template>
    <div>
        <table class="color-seat table table-noborder mb-0" style="background: #E8E8E8;">
            <tbody>
            <tr class="seat-guid-row" style="border-bottom:1px solid #ddd">
                <td>
                    <p class="mb-0">
                    </p>
                    <div class="ml-1 seat-legend seat_empty"></div>
                    <span style="float:left; font-size: 12px">Ghế trống</span>
                </td>
                <td>
                    <p class="mb-0">
                    </p>
                    <div class="ml-1 seat-legend seat-not-selected"></div>
                    <span style="float:left; font-size: 12px">Ghế không bán</span>
                </td>
                <td>
                    <p class="mb-0">
                    </p>
                    <div class="ml-1 seat-legend seat-selected"></div>
                    <span style="float:left; font-size: 12px">Đang chọn</span>
                </td>
            </tr>

            </tbody>
        </table>
        <div class="cd-sodoghe mt-3">
            <table class="table table-noborder mb-0">
                <tbody>
                    <tr :key="i + '-row'" v-for="(row, i) in seats_available">
                        <td :key="col.id" v-for="col in row">
                        <img v-if="getProp(col, 'p_col', 0) === 0 && getProp(col, 'p_row', 0) === 0 && !getProp(col, 'selectable', false)"
                             width="25"
                             style="max-width: none"
                             class="img-responsive"
                             id="vo-lang" alt=""
                             src="../../../../assets/images/steering-wheel.svg">

                        <div v-if="getProp(col, 'selectable', true) && getProp(col, 'pivot.order_id') === 0"
                             :title="'Số ghế: ' + col.p_row + '.' + col.p_col + ', Giá: ' + (ticket_price_common + col.addition_price).toLocaleString('us')">
                            <a href="javascript:void(0)" @click="selectSeat(col)">
                                <div class="cd-so-ghe">
                                    <div class="img-responsive bed-img">
                                        <seat :fill="value.includes(col) ? 'rgb(186, 223, 65)': '#fff'"></seat>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div v-if="getProp(col, 'selectable', true) && getProp(col, 'pivot.order_id') !== 0"
                             :title="'Số ghế:' + col.p_row + '.' + col.p_col + ', Giá:' + (ticket_price_common + col.addition_price).toLocaleString('us')">
                            <a href="javascript:void(0)">
                                <div class="cd-so-ghe">
                                    <div class="img-responsive bed-img">
                                        <seat fill="rgb(166, 166, 166)"></seat>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Seat from "./Seat";
    import {MixinHelper} from "../../../shared/services";
    export default {
        name: "SeatMap",
        mixins: [MixinHelper],
        components: {Seat},
        props: {
            value: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            seats_available: {
                type: Array,
                required: true
            },
            ticket_price_common: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                total_price: 0
            }
        },
        methods: {
            selectSeat(seat) {
                // if (this.value.includes(seat.id)) {
                //     this.value.splice(this.value.indexOf(seat.id), 1);
                //     this.total_price = this.total_price - seat.addition_price - this.ticket_price_common;
                // } else {
                //     this.value.push(seat.id);
                //     this.total_price = this.total_price + seat.addition_price + this.ticket_price_common;
                // }
                // this.$emit('totalPrice', this.total_price);
                // this.emitVal();

                if (this.value.includes(seat)) {
                    this.value.splice(this.value.findIndex(s => s.id === seat.id), 1);
                    this.total_price = this.total_price - seat.addition_price - this.ticket_price_common;
                } else {
                    this.value.push(seat);
                    this.total_price = this.total_price + seat.addition_price + this.ticket_price_common;
                }
                // this.$emit('totalPrice', this.total_price);
                this.emitVal();
            },
            emitVal() {
                this.$emit('input', this.value)
            }
        }
    }
</script>

<style scoped>

    .table-noborder, .table-noborder td {
        border: 0 !important;
    }

    .table {
        width: 100%;
        max-width: 100%;
        margin-bottom: 20px;
    }
    .seat-guid-row div {
        border-radius: 3px;
    }

    .cd-sodoghe {
        border: 1px solid #f1f1f1;
        padding: 5px;
        background: #fbfbfb;
        position: relative;
    }

    .img-responsive {
        display: block;
        max-width: 100%;
        height: auto;
    }

    .bed-img, .bed-img .replaced-svg {
        max-height: 25px !important;
    }

    .bed-img .replaced-svg {
        width: 100%;
    }

    #vo-lang {
        transform: rotate(90deg);
        margin: auto;
    }

    .seat-legend {
        display: inline-block;
        width: 15px;
        height: 15px;
        float:left;
        margin-right:5px;
    }

    .seat_empty {
        border: 1px solid #919191;
        background-color:#fff;
    }

    .seat-not-selected {
        border: 1px solid #CFCFCF;
        background-color:#CFCFCF;
    }

    .seat-selected {
        border: 1px solid #BADF41;
        background-color: #BADF41;
    }
</style>
